import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

const isAuthenticated = () => {
  // Check if auth token exists in localStorage
  const isLoggedIn = localStorage.getItem("is_logged_in");
  return !!isLoggedIn;
};

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: () => {
    // If user is not authenticated, redirect to login
    if (!isAuthenticated()) {
      throw redirect({
        to: "/login",
        // search: {
        //   redirect: location.pathname,
        // },
      });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return <Outlet />;
}
